<template>
  <div class="success-page">
    <p class="section-title multiple-stars">{{ __('form_submitted_title')! }}</p>
    <div class="title-text">{{ __('submitted_successfully') }}</div>
    <template v-if="store.submittedData">
      <div class="success-page-data">
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('submitted_date') }}</div>
          <div class="list-text">
            {{ store.submittedData.time.format('EEEE, dd.MM') }}
          </div>
        </div>
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('appointment_time') }}</div>
          <div class="list-text">
            {{ store.submittedData.time.format('HH:mm') }}
          </div>
        </div>
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('form_visit_reason') }}</div>
          <div class="list-text">
            {{ __(store.submittedData.visitType) }}
          </div>
        </div>
      </div>
      <div class="success-page-data">
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('form_locations') }}</div>
          <div class="list-text">
            {{ store.submittedData.location }}
          </div>
        </div>
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('form_doctor') }}</div>
          <div class="list-text">
            {{ store.submittedData.doctor }}
          </div>
        </div>
        <div class="success-page-data-box"></div>
      </div>
      <div class="success-page-data" v-if="store.submittedData.comment">
        <div class="success-page-data-box">
          <div class="small-list-text-uppercase">{{ __('comment_reason') }}</div>
          <div class="list-text">
            {{ store.submittedData.comment }}
          </div>
        </div>
      </div>
      <div class="success-page-calendar">
        <div class="title-text">{{ __('add_to_calendar') }}</div>
        <div class="success-page-calendar-buttons">
          <div class="success-page-calendar-buttons-button button" @click="addToCalendar('apple')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M16.6212 0C16.677 0 16.7329 0 16.7919 0C16.9289 1.69253 16.2829 2.95719 15.4977 3.87301C14.7273 4.78251 13.6724 5.6646 11.9662 5.53076C11.8523 3.86247 12.4994 2.69161 13.2835 1.77789C14.0107 0.92636 15.3439 0.168621 16.6212 0Z"
                fill="white" />
              <path
                d="M21.7851 17.6169C21.7851 17.6337 21.7851 17.6485 21.7851 17.6643C21.3056 19.1165 20.6216 20.3612 19.7869 21.5162C19.025 22.5648 18.0912 23.976 16.424 23.976C14.9833 23.976 14.0264 23.0496 12.5499 23.0243C10.9881 22.999 10.1292 23.7989 8.70116 24.0002C8.53781 24.0002 8.37446 24.0002 8.21427 24.0002C7.16566 23.8485 6.3194 23.018 5.70288 22.2698C3.88493 20.0587 2.48011 17.2027 2.21875 13.5478C2.21875 13.1895 2.21875 12.8323 2.21875 12.4739C2.32941 9.85821 3.60039 7.73148 5.28976 6.70079C6.18134 6.15277 7.407 5.6859 8.77177 5.89457C9.35668 5.9852 9.95423 6.18544 10.478 6.38357C10.9744 6.57432 11.5951 6.91262 12.1832 6.8947C12.5815 6.88311 12.9778 6.67549 13.3793 6.529C14.5555 6.10429 15.7084 5.6174 17.2281 5.84609C19.0545 6.12221 20.3507 6.93369 21.1517 8.1857C19.6067 9.16897 18.3853 10.6507 18.5939 13.1811C18.7794 15.4796 20.1157 16.8244 21.7851 17.6169Z"
                fill="white" />
            </svg>
          </div>
          <div class="success-page-calendar-buttons-button button" @click="addToCalendar('google')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M0 12C0 5.3832 5.3832 0 12 0C14.6723 0 17.2017 0.859771 19.3147 2.4864L16.5262 6.1088C15.2197 5.10309 13.6545 4.57143 12 4.57143C7.90389 4.57143 4.57143 7.90389 4.57143 12C4.57143 16.0961 7.90389 19.4286 12 19.4286C15.2991 19.4286 18.1026 17.2671 19.0688 14.2857H12V9.71429H24V12C24 18.6168 18.6168 24 12 24C5.3832 24 0 18.6168 0 12Z"
                fill="white" />
            </svg>
          </div>
          <div class="success-page-calendar-buttons-button button" @click="addToCalendar('microsoft')">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <g clip-path="url(#clip0_732_5443)">
                <path
                  d="M19.8348 1.85112L13.418 0.0177734C13.3181 -0.0108875 13.2114 -0.0047428 13.1154 0.0351762L2.11517 4.61864C1.94479 4.68993 1.83385 4.85652 1.83376 5.04125V16.9582C1.83376 17.2096 2.03619 17.414 2.28752 17.4166C2.03439 17.4181 1.83045 17.6246 1.83204 17.8777C1.83324 18.0747 1.96018 18.2488 2.14727 18.3103L13.1475 21.9771C13.1943 21.9922 13.2432 21.9999 13.2924 22C13.3349 21.9997 13.3772 21.9935 13.418 21.9816L19.8348 20.1482C20.0314 20.0922 20.1672 19.9127 20.1676 19.7082V2.29114C20.1672 2.08669 20.0314 1.90716 19.8348 1.85112ZM2.49743 17.368L5.2475 15.9929C5.40258 15.9152 5.5005 15.7566 5.5005 15.5832V5.85798L13.7507 3.79542V19.1738L2.36173 17.422C2.3402 17.4184 2.31846 17.4166 2.29663 17.4165C2.36637 17.4156 2.43499 17.399 2.49743 17.368Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_732_5443">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </template>

    <p class="body-text">{{ __('appointment_reserved_description') }}</p>
    <router-link
      :to="{
        name: 'LandingPage',
      }"
      class="success-page-back">
      <div class="arrow left-arrow"></div>
      <p class="body-text-bold primary-text">
        {{ __('back_to_home_screen') }}
      </p>
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { generalStore } from '@/store';
import __ from '@/translate';

const store = generalStore();

const addToCalendar = (calendar: 'apple' | 'google' | 'microsoft') => {
  if (!store.submittedData) return;

  const { time } = store.submittedData;
  const title = __('add_to_calendar_title');
  const description = `${__('calendar_title_hey')}, ${time.format('dd.MM')}  ${time} ${__(
    'add_to_calendar_description'
  )}.`;
  const location = store.submittedData.location || 'Kopitarjev trg 1, 1217 Vodice';
  const url = window.location.href;

  const startDate = time.toUTC();

  const endDate = startDate.plus({ minutes: 30 });

  if (calendar === 'apple') {
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${startDate.format("yyyyMMdd'T'HHmmss'Z'")}
DTEND:${endDate.format("yyyyMMdd'T'HHmmss'Z'")}
SUMMARY:${title}
DESCRIPTION:${description}
LOCATION:${location}
END:VEVENT
END:VCALENDAR`;
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'event.ics';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
  } else if (calendar === 'google') {
    // https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20241122T131500Z%2F20241122T134500Z
    window.open(
      `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
        title
      )}&dates=${startDate.format("yyyyMMdd'T'HHmmss'Z'")}/${endDate.format(
        "yyyyMMdd'T'HHmmss'Z'"
      )}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&sprop=${encodeURIComponent(
        url
      )}`,
      '_blank'
    );
  } else if (calendar === 'microsoft') {
    console.log(
      `https://outlook.live.com/calendar/0/action/compose?allday=false&body=${encodeURIComponent(
        description
      )}&enddt=${endDate.format("yyyy-MM-dd'T'HH:mm:ss")}&location=${encodeURIComponent(
        location
      )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${startDate.format(
        "yyyy-MM-dd'T'HH:mm:ss"
      )}&subject=${encodeURIComponent(title)}`
    );
    // https://outlook.live.com/calendar/0/action/compose?allday=false&body=Hej%2C%2003.12%20ob%2011%3A00%20uri%20imate%20rezerviran%20termin%20pri%20zobozdravnici.&enddt=2024-12-03T10:30:00&location=Kopitarjev%20trg%201%2C%201217%20Vodice&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2024-12-03T10:00:00&subject=Termin%20pri%20zobozdravnici%20-%20Nordic%20Dental
    // https://outlook.live.com/calendar/0/action/compose?allday=false&body=Hej%2C%2003.12%20ob%2011%3A30%20uri%20imate%20rezerviran%20termin%20pri%20zobozdravnici.&enddt=2024-12-03T12%3A30%3A00&location=Kopitarjev%20trg%201%2C%201217%20Vodice&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2024-12-03T12%3A00%3A00&subject=Termin%20pri%20zobozdravnici%20-%20Nordic%20Dental
    window.open(
      `https://outlook.live.com/calendar/0/action/compose?allday=false&body=${encodeURIComponent(
        description
      )}&enddt=${endDate.setZone('Europe/Ljubljana').format("yyyy-MM-dd'T'HH:mm:ss")}&location=${encodeURIComponent(
        location
      )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${startDate
        .setZone('Europe/Ljubljana')
        .format("yyyy-MM-dd'T'HH:mm:ss")}&subject=${encodeURIComponent(title)}`,
      '_blank'
    );
  }
};
</script>
